module.exports = __webpack_public_path__ + "static/media/warning.6f822b98.svg";